import React, { useState } from 'react';
import { getFullName, isRTL } from '../../../services/userModel.js';
import { MODAL_COMPONENT_TYPE, WAITER_TYPES } from '../../../utils/enums.js';
import Waiter from '../Waiter/Waiter.jsx';

import classNames from 'classnames';
import './index.scss';
import IconButton from '../IconButton/IconButton.jsx';
import CustomersListModal from '../CustomersListModal/index.js';
import { useDispatch } from 'react-redux';
import { createAction } from '../../../utils/sagaHelper.js';
import i18n from 'i18next';
import ConfirmDialog from '../../containers/ConfirmDialogContainer/index.js';
import CustomersListTable from '../CustomersListModal/CustomersListTable.jsx';

const getModelByType = modelType => {
  switch (modelType) {
    case MODAL_COMPONENT_TYPE.customersList:
      return CustomersListModal;
    default:
      return null;
  }
};

const getTableByModelType = modelType => {
  switch (modelType) {
    case MODAL_COMPONENT_TYPE.customersList:
      return CustomersListTable;
    default:
      return null;
  }
};

export const PrintSelectedItems = ({ selectedItems, handleDeleteItem, idKey }) => {
  return (
    <div className={classNames('modalSelectItem')} style={{ gap: '16px' }}>
      {selectedItems?.map(item => (
        <div key={item[idKey]} className={classNames('item')}>
          {getFullName(item)}
          <IconButton isIcon iconName={'iconPlus'} onClick={() => handleDeleteItem(item)} />
        </div>
      ))}
    </div>
  );
};

const SectionItemModalSelect = ({ column, item }) => {
  const dispatch = useDispatch();
  const [selectedItems, setSelectedItems] = useState([]);
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [tableItems, setTableItems] = useState([]);
  const { saveTitle, openPopupTitle, saveAction, defaultTitle } = column?.buttonsConfig || {};

  const idKey = column.key || 'id';
  const ModalComponent = getModelByType(column?.modalType);
  const TableComponent = getTableByModelType(column.modalType);

  const handleOnSaveAction = () => {
    const selectedItemsIds = selectedItems.map(item => item[idKey]);
    return new Promise((resolve, reject) => {
      dispatch(createAction(saveAction, { selectedItems: selectedItemsIds, item })).then(
        data => {
          resolve();
          setTableItems([data, ...tableItems]);
          setIsOpenConfirm(false);
        },
        () => {
          setIsOpenConfirm(false);
          reject();
        }
      );
    });
  };

  const handleSetItems = items => {
    setSelectedItems(items);
  };

  const handleDeleteItem = deleteItem => {
    setSelectedItems(selectedItems.filter(item => item[idKey] !== deleteItem[idKey]));
  };

  const ModalControls = () => {
    return (
      <div className={classNames('modalSelectItemControls')}>
        {!!selectedItems?.length && !isOpenConfirm && (
          <Waiter
            type={WAITER_TYPES.button}
            useClass={classNames('btn', 'confirm')}
            stopPropagation={true}
            spanText={i18n.t(saveTitle)}
            handleOnClick={() => setIsOpenConfirm(true)}
          />
        )}
        {!isOpenConfirm && (
          <button className={classNames('btn', 'denied')} onClick={() => setIsOpenPopup(true)}>
            {!!selectedItems?.length ? i18n.t(openPopupTitle) : i18n.t(defaultTitle)}
          </button>
        )}
        {isOpenConfirm && (
          <ConfirmDialog
            useWrapperClass={classNames('confirmDialog')}
            useBtnConfirmClass={classNames('btn confirm btnConfirmDialog')}
            handleOnConfirm={handleOnSaveAction}
            handleOnCancel={() => setIsOpenConfirm(false)}
          />
        )}
      </div>
    );
  };

  return (
    <div className={classNames('sectionItemModalSelect', { rtl: isRTL() })}>
      <div className={classNames('modalSelectItem title')}>
        <span>{i18n.t(column.title)}</span>
        <ModalControls />
      </div>
      {!!selectedItems?.length && (
        <PrintSelectedItems selectedItems={selectedItems} handleDeleteItem={handleDeleteItem} idKey={idKey} />
      )}
      {TableComponent && !!tableItems?.length && (
        <div className={classNames('modalSelectItem')}>
          <TableComponent values={tableItems} />
        </div>
      )}

      <div
        className={classNames('layoutContainer', {
          open: isOpenPopup,
        })}
      >
        <ModalComponent
          idKey={idKey}
          isOpen={isOpenPopup}
          selectedItems={selectedItems}
          onSaveItems={handleSetItems}
          handleClosePopup={() => setIsOpenPopup(false)}
        />
      </div>
    </div>
  );
};

export default SectionItemModalSelect;
